$(document).ready(function () {
  // Sticky Header
  $(window).scroll(function(){
    if ($(window).scrollTop()) {
      $('.header-wrapper').addClass('sticky');
    }
    else {
      $('.header-wrapper').removeClass('sticky');
    }
  });
  
  // Accordion
  $(".accordion").on("click", ".acc-title", function () {
    $(this).toggleClass("active").siblings(".acc-content").slideToggle();
    $(this)
      .parents(".accordion")
      .find(".acc-title")
      .not(this)
      .removeClass("active")
      .siblings(".acc-content")
      .slideUp();
  });
  $(
    ".page-engagement-rings .accordion .acc-title, .page-diamonds .accordion .acc-title, .page-wedding-bands .accordion .acc-title, .page-fine-jewelry .accordion .acc-title"
  ).addClass("active");

  // Tabs
  $(
    ".tabs .tabs-nav li:first-child, .tabs .tabs-content-wrapper .tab-content:first-child"
  ).addClass("active");
  $(".tabs .tabs-nav li").on("click", function () {
    let dataTab = $(this).attr("data-tab");
    $(this).addClass("active").siblings().removeClass("active");
    $('[data-id="' + dataTab + '"]')
      .addClass("active")
      .siblings()
      .removeClass("active");
  });

  // Announcement bar
  if ($(".announcement-bar").length) {
    $(".announcement-bar").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      adaptiveHeight: false,
      autoplay: true,
      autoplaySpeed: 5000,
      // speed: 500,
      // fade: true,
      // cssEase: 'linear'
    });
  }

  // Main Slider
  // var home_main_slider = $(".home-main-slider");
  // var home_main_slider_image = home_main_slider.find(".slide");
  // if (home_main_slider.length && home_main_slider_image.length > 1) {
  //   home_main_slider.slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     dots: true,
  //     arrows: false,
  //     adaptiveHeight: true,
  //     autoplay: true,
  //     autoplaySpeed: 5000,
  //     pauseOnFocus: false,
  //   });
  // }

  const diamond_grid = $(".diamonds-grids");
  if ($(window).width() > 750) {
    if (diamond_grid.length) {
      $(".diamonds-grids").slick({
        slidesToShow: 9,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              variableWidth: true,
            },
          },
        ],
      });
    }
  }

  // Reviews Slider
  let reviewSlider = $(".reviews-slider");
  if (reviewSlider.length) {
    reviewSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  }

  // Home - Reviews Slider
  let $homeReviewSlider = $(".home-reviews-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    fade: true,
  });
  $(".home-reviews-slider .reviews-item").click(function () {
    $homeReviewSlider.slick(
      "slickGoTo",
      parseInt($homeReviewSlider.slick("slickCurrentSlide")) + 1
    );
  });

  let googleReviewSlider = $(".google-reviews-slider");
  if (googleReviewSlider.length) {
    googleReviewSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      adaptiveHeight: true,
    });
  }

  // center columns section
  if ($(window).width() < 750) {
    const center_columns_slider = $(".center-columns-slider");
    if (center_columns_slider.length) {
      center_columns_slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        adaptiveHeight: true,
        infinite: false,
      });
    }
  }

  // default-slick-slider slider
  function slickSetting(
    slides_to_show,
    show_dots,
    show_arrows,
    show_infinite,
    show_adaptiveHeight,
    show_autoplay
  ) {
    return {
      dots: show_dots,
      arrows: show_arrows,
      slidesToShow: slides_to_show,
      speed: 500,
      infinite: show_infinite,
      slidesToScroll: 1,
      autoplay: show_autoplay,
      autoplaySpeed: 4000,
      adaptiveHeight: show_adaptiveHeight,
      rows: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
          },
        },
      ],
    };
  }
  var slickSlider = {
    defaltSlickSlider: function () {
      $("[data-home-slick-slider]").each(function () {
        var slides_to_show = parseInt($(this).data("product-count")) || 4;
        var show_dots = $(this).data("dots") || false;
        var show_arrows = $(this).data("arrows") || false;
        var show_infinite = $(this).data("infinite") || false;
        var show_adaptiveHeight = $(this).data("adaptiveHeight") || false;
        var show_autoplay = $(this).data("autoplay") || false;
        $(this).slick(
          slickSetting(
            slides_to_show,
            show_dots,
            show_arrows,
            show_infinite,
            show_adaptiveHeight,
            show_autoplay
          )
        );
      });
    },
    customCategorySlider: function () {
      var $slick_slider = $("[data-style-slick-slider]");

      // console.log("customCategoryCol: " + $customCategoryCol);
      var slickSetting = {
        dots: false,
        arrows: true,
        slidesToShow: 4,
        speed: 500,
        infinite: false,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4000,
        adaptiveHeight: false,
        rows: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      };
      if ($slick_slider.length) {
        $slick_slider.each(function () {
          slickSetting.slidesToShow = $(this).data("limit");
          $(this).slick(slickSetting);
        });
      }
    },
  };
  // slickSlider.defaltSlickSlider();
  slickSlider.customCategorySlider();

  // Function to change collection tab
  $(".collection-tab-wrapper .collection-tab-title").on("click", function () {
    $(".collection-tab-wrapper .collection-tab-title").removeClass("active");
    $(this).addClass("active");
    var collection_id = $(this).data("tab-id");
    $(".collection-tab-content").removeClass("active");
    $("#" + collection_id).addClass("active");
  });

  // Home - Trending Now
  $(".home-trending-now-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1.4,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Home - Featured Deals
  $(".home-engagement-rings-slider").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          dots: true,
        },
      },
    ],
    customPaging: function (slider, i) {
      //FYI just have a look at the object to find aviable information
      console.log(slider);
      var slideNumber = (i + 1),
        totalSlides = slider.slideCount;
      // return '<span class="dot" title="' + slideNumber + ' of ' + totalSlides + '"><span class="string">' + slideNumber + '/' + totalSlides + '</span></span>';
      return '<span id="slick-slide-control30" tabindex="-1">' + slideNumber + '</span>';
    }
  });

  // Instagram feed
  $(".instafeed-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  // Page - Diamonds
  // browse collection
  if ($(window).width() < 750) {
    const diamond_collection_slider = $(".diamonds-collection-slider");
    if (diamond_collection_slider.length) {
      diamond_collection_slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      });
    }
  }

  // Page - Wedding Band Education
  let weddingBandEduSlider = $(".wedding-band-education-slider");
  if (weddingBandEduSlider.length) {
    weddingBandEduSlider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  let tabsheadingSlider = $(".tabs-heading-slider");
  if (tabsheadingSlider.length) {
    tabsheadingSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      asNavFor: ".tabs-content-slider",
    });
  }
  let tabsContentSlider = $(".tabs-content-slider");
  if (tabsContentSlider.length) {
    tabsContentSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      asNavFor: ".tabs-heading-slider",
    });
  }

  let tabs_ContentSlider = $(".tabs_content-slider");
  let tabs_contentSliderOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
  };
  if (tabs_ContentSlider.length) {
    tabs_ContentSlider.slick(tabs_contentSliderOptions);
  }
  $(".slider-inside-tabs .tabs .tabs-nav li").on("click", function () {
    tabs_ContentSlider.slick("unslick");
    tabs_ContentSlider.slick(tabs_contentSliderOptions);
  });

  // Wedding - Choose metal
  let chooseMetal = $(".choose-metal .acc-title");
  chooseMetal.on("click", function () {
    let dataTitle = $(this).attr("data-title");
    $('.choose-metal [data-id="' + dataTitle + '"]')
      .addClass("scale-it")
      .siblings()
      .removeClass("scale-it");
  });

  // Page - Our Jewelry
  let jewelryCatalogSlider = $(".jewelry-catalog-slider");
  if ($(window).width() < 750) {
    if (jewelryCatalogSlider.length) {
      jewelryCatalogSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      });
    }
  }

  let textColumnSlider = $(".text-columns-slider");
  if (textColumnSlider.length) {
    textColumnSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
    });
  }

  // Multi Slider
  var numSlick = 0;
  $(".multi-slider").each(function () {
    numSlick++;
    let $this = $(this);
    let $multiTitleSlider = $(this)
      .find(".multi-title-slider")
      .addClass("slider-" + numSlick);
    let $multiContentSlider = $(this)
      .find(".multi-content-slider")
      .addClass("slider-" + numSlick);
    let slideNum = $multiTitleSlider.find(".slide").length;
    let slideToShow = parseInt($multiTitleSlider.attr("data-slides"));

    $multiContentSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      adaptiveHeight: true,
      draggable: false,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            draggable: true,
          },
        },
      ],
    });
    if ($multiTitleSlider.hasClass("slick-slider")) {
      $multiContentSlider.slick(
        "slickSetOption",
        "asNavFor",
        ".multi-title-slider.slider-" + numSlick,
        true
      );
    }

    if (!$this.parents().hasClass("multi-slider-v1")) {
      if (slideNum > slideToShow || $(window).width() < 750) {
        $multiTitleSlider.slick({
          vertical: false,
          slidesToShow: slideToShow,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          draggable: false,
          focusOnSelect: true,
          asNavFor: ".multi-content-slider.slider-" + numSlick,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      }
      $multiTitleSlider.find("div[data-slide]").on("click", function () {
        $(this).addClass("active").siblings().removeClass("active");
        var slideno = $(this).data("slide");
        $multiContentSlider.slick("slickGoTo", slideno - 1);
      });
      $multiContentSlider.on(
        "afterChange",
        function (event, slick, currentSlide) {
          // console.log(currentSlide);
          var index = currentSlide + 1;
          $multiTitleSlider.find(".slide").removeClass("active");
          $multiTitleSlider.find(".slide.slide_" + index).addClass("active");
        }
      );
    }

    // V1
    if ($this.parents().hasClass("multi-slider-v1")) {
      if (slideNum > slideToShow || ($(window).width() < 750 && slideNum > 2)) {
        $multiTitleSlider.slick({
          vertical: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          draggable: false,
          focusOnSelect: true,
          variableWidth: true,
          infinite: true,
          asNavFor: ".multi-content-slider.slider-" + numSlick,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                variableWidth: true,
                slidesToShow: 1,
              },
            },
          ],
        });
      }

      $multiTitleSlider.find("div[data-slide]").on("click", function () {
        $(this).addClass("active").siblings().removeClass("active");
        if ($multiTitleSlider.hasClass("slick-slider")) {
          var slideno = $(this).data("slick-index");
          $multiContentSlider.slick("slickGoTo", slideno);
        } else {
          var slideno = $(this).data("slide");
          $multiContentSlider.slick("slickGoTo", slideno - 1);
        }
      });
      if ($multiTitleSlider.hasClass("slick-slider")) {
        $multiContentSlider.on(
          "afterChange",
          function (event, slick, currentSlide) {
            var dataIndex = $(slick.$slides[currentSlide]).data("slick-index");
            $multiTitleSlider.slick("slickGoTo", dataIndex);
            $multiTitleSlider
              .find(".slide.slick-current")
              .addClass("active")
              .siblings()
              .removeClass("active");
          }
        );
      } else {
        $multiContentSlider.on(
          "afterChange",
          function (event, slick, currentSlide) {
            var index = currentSlide + 1;
            $multiTitleSlider.find(".slide").removeClass("active");
            $multiTitleSlider.find(".slide.slide_" + index).addClass("active");
          }
        );
      }
    }
  });

  // Tabs hover slider
  $(".tabs-hover-slider").each(function () {
    let $tabsIconSlider = $(".tab-icons-slider");
    let $tabsContentSlider = $(".tab-content-slider");

    if ($(window).width() < 750) {
      $tabsIconSlider.slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        draggable: false,
        focusOnSelect: true,
        infinite: false,
        asNavFor: ".tab-content-slider",
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1,
              infinite: true,
              fade: true,
              cssEase: "linear",
            },
          },
        ],
      });
    }

    $tabsContentSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: false,
      fade: true,
      cssEase: "linear",
      draggable: false,
      speed: 100,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            draggable: true,
            infinite: true,
            asNavFor: ".tab-icons-slider",
            dots: true,
          },
        },
      ],
    });

    $(".tab-icons-slider .tab-icon").on("mouseover", function () {
      $(this).addClass("slick-current").siblings().removeClass("slick-current");
      $tabsContentSlider.slick("slickGoTo", $(this).index());
    });
  });

  // Video play/pause functionality
  $(".video-box .video-pre-icon #play").on("click", function () {
    $(this).closest(".video-box").find("video").trigger("play");
    $(this).closest(".video-box").find(".video-poster").hide();
    $(this).closest(".video-box").find(".video-content").hide();
    $(this).closest(".video-box").find(".video-pre-icon #stop").show();
    $(this).hide();
  });
  $(".video-box .video-pre-icon #stop").on("click", function () {
    $(this).closest(".video-box").find("video").trigger("pause");
    $(this).closest(".video-box").find(".video-pre-icon #play").show();
    $(this).hide();
  });
  $(".video-box video").on("ended", function () {
    $(this).closest(".video-box").find(".video-poster").show();
    $(this).closest(".video-box").find(".video-content").show();
    $(this).closest(".video-box").find(".video-pre-icon #play").show();
    $(this).closest(".video-box").find(".video-pre-icon #stop").hide();
  });
  // Load video on nav hover
  $(".site-nav--has-dropdown.engagement").on("mouseenter", function () {
    var video = $("#vid-engagement");
    video[0].play();
  });

  // Blog page
  $(".blogs-nav .toggle-icon").on("click", function () {
    $(this).siblings(".blog-nav__childlist").slideToggle();
    $(this).toggleClass("active");
  });

  const article_slider = $(".featured-articles-slider");
  if (article_slider.length) {
    $(".featured-articles-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
    });
  }

  let blogListSlider = $(".bloglist-slider");
  blogListSlider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    adaptiveHeight: true,
    prevArrow:
      '<button class="slick-prev"><svg id="arrow_prev" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27"><g id="Group_53" data-name="Group 53" transform="translate(0 0)"><path id="Path_19" data-name="Path 19" d="M1.688,13.5A11.812,11.812,0,1,0,13.5,1.688,11.812,11.812,0,0,0,1.688,13.5ZM27,13.5A13.5,13.5,0,1,1,13.5,0,13.5,13.5,0,0,1,27,13.5Zm-7.594-.844a.844.844,0,0,1,0,1.688H9.631l3.623,3.621a.845.845,0,0,1-1.195,1.195L7,14.1A.844.844,0,0,1,7,12.9L12.059,7.84a.845.845,0,0,1,1.195,1.195L9.631,12.656Z" transform="translate(0 0)" fill-rule="evenodd"/></g></svg></button>',
    nextArrow:
      '<button class="slick-next"><svg id="arrow_next" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27"><g id="Group_53" data-name="Group 53" transform="translate(0 0)"><path id="Path_19" data-name="Path 19" d="M1.688,13.5A11.812,11.812,0,1,0,13.5,1.688,11.812,11.812,0,0,0,1.688,13.5ZM27,13.5A13.5,13.5,0,1,1,13.5,0,13.5,13.5,0,0,1,27,13.5Zm-7.594-.844a.844.844,0,0,1,0,1.688H9.631l3.623,3.621a.845.845,0,0,1-1.195,1.195L7,14.1A.844.844,0,0,1,7,12.9L12.059,7.84a.845.845,0,0,1,1.195,1.195L9.631,12.656Z" transform="translate(0 0)" fill-rule="evenodd"/></g></svg></button>',
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  // Home preview page
  const custom_ring_slider = $(".customize-ring-slider");
  if (custom_ring_slider.length) {
    $(".customize-ring-slider").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // Home - Customer reviews
  const home_customer_slider = $(".home-customer__slider");
  if (home_customer_slider.length) {
    $(".home-customer__slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      adaptiveHeight: true,
      // responsive: [
      //   {
      //     breakpoint: 1025,
      //     settings: {
      //       slidesToShow: 3,
      //     },
      //   },
      //   {
      //     breakpoint: 750,
      //     settings: {
      //       slidesToShow: 1,
      //     },
      //   },
      // ],
    });
  }

  // Page - Our policies
  const policy_heading_slider = $(".policy-heading-slider");
  if (policy_heading_slider.length) {
    $(".policy-heading-slider").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  // PDP - Product features
  const product_feature_slider = $(".product-features-slider");
  if (product_feature_slider.length) {
    $(".product-features-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
  // Page - Monthly payment option
  $(".payment-nav a").on("click", function (e) {
    e.preventDefault();
    let pay_id = $(this).attr("href");
    $(this).addClass("active").siblings().removeClass("active");
    $(pay_id).show().siblings().hide();
  });

  if ($(window).width() < 750) {
    // Icon text columns
    const icon_text_slider = $(".icon-text-columns-slider");
    if (icon_text_slider.length) {
      $(".icon-text-columns-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        adaptiveHeight: true,
      });
    }

    $(".feature-column-content-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      adaptiveHeight: true,
      infinite: false,
    });

    $(".two-columns-row").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
    });
  }

  // Page navigation
  $(".page-navigation").each(function () {
    let activeLink = $(this).find("li.active");
    $(activeLink).on("click", function () {
      $(this).siblings().toggle();
      $(this).toggleClass("open-nav");
    });
  });
  // Google client
  try {
    var googleClientId = Cookies.get("_ga");
    // console.log(googleClientId);
    var split_id = googleClientId.split(".");
    $(".google-client-id").text(`${split_id[2]}.${split_id[3]}`);
  } catch (e) {
    console.log(e);
  }
  // freshDesk popup on chat click
  $(".help-grids .button-chat").on("click", function () {
    console.log(1);
    FreshworksWidget("open");
  });
  // Customize engagement rings popup
  $("#custom-design-request").on("click", function () {
    console.log("test");
    theme.open_popup($("#custom-design-request-popup"));
  });
  $("#design-custom-ring").on("click", function () {
    theme.open_popup($("#custom-design-request-popup"));
  });
  $("#custom-design-request-popup .close-button").on("click", function () {
    theme.close_popup();
  });

  // Diamond event banner popup (Home main slider)
  $(".banner-spend-more-get-more .know-more").on("click", function () {
    $("#diamond-event-popup").show();
  });
  $("#diamond-event-popup .close-popup,#diamond-event-popup .popup_overlay").on(
    "click",
    function () {
      $("#diamond-event-popup").hide();
    }
  );
  // Back to top - Js
  var btn = $(".back-to-top");
  $(window).scroll(function () {
    if ($(window).scrollTop() > 1200) {
      btn.show();
    } else {
      btn.hide();
    }
  });
  btn.on("click", function (e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, "300");
  });
  // show popup on more info click
  $(document).on("click", ".product-infromation .more-info-icon", function () {
    $("body").addClass("show-website-popup");
    $("#more-info-icon-popup").addClass("show-popup-content");
  });
  // Exteded Returns popup code
  // $(document).on("click", ".extented-returns-popup-button", function () {
  //   $("body").addClass("show-website-popup");
  //   $("#extended-return-popup").addClass("show-popup-content");
  // });
  // Holiday Diamond Event Terms popup code
  $(document).on("click", ".holiday-diamond-event-popup-btn", function () {
    $("body").addClass("show-website-popup");
    $("#holiday-diamond-event-popup").addClass("show-popup-content");
  });
  // load pdp video on scroll
  $(window).scroll(function () {
    $(".holiday-diamond-event video").length &&
      $(".holiday-diamond-event video")[0].play();
  });
  $(document).on("click", ".holiday-diamond-event-popup-btn", function () {
    $(".holiday-diamond-event-desc video")[0].play();
  });

  // Diamond Quality popup code
  $(document).on("click", ".diamond-color-popup-btn", function () {
    $("body").addClass("show-website-popup");
    $("#diamond-color-popup").addClass("show-popup-content");
  });
  $(document).on("click", ".diamond-clarity-popup-btn", function () {
    $("body").addClass("show-website-popup");
    $("#diamond-clarity-popup").addClass("show-popup-content");
  });
  $(document).on("click", ".diamond-quality-popup-btn", function () {
    $("body").addClass("show-website-popup");
    $("#diamond-quality-popup").addClass("show-popup-content");
  });

  // Clarity Commitment popup code
  $(document).on("click", ".clarity-commitment-popup-btn", function () {
    $("body").addClass("show-website-popup");
    $("#clarity-commitment-popup").addClass("show-popup-content");
  });

  // Metal Guide popup code
  $(document).on("click", ".metal-guide-popup-btn", function () {
    $("body").addClass("show-website-popup");
    $("#metal-guide-popup").addClass("show-popup-content");
  });

  //Code to remove desktop and mobile country selector in mobile and desktop respectively
  if ($(window).width() > 1199) {
    $(".mob_country-selector").remove();
  } else {
    $(".desk_country-selector").remove();
  }
  var current_country_code = theme.country_iso_code;
  if (current_country_code != "US") {
    $(".site-nav .site-nav__child-link.home-preview").hide();
    $(".mobile-nav .mobile-nav__level-1.home-preview").hide();
    $(".product-single__meta .product__addon-home-preveiw").hide();
    $("#footer-link_home-preview").hide();
  }
  // Add overlay background to page-container on navigation hover
  $("#SiteNav")
    .on("mouseenter", function () {
      $("#PageContainer").addClass("nav-hover");
    })
    .on("mouseleave", function () {
      $("#PageContainer").removeClass("nav-hover");
    });

  // #SiteNav - Show navigation on mouseenter and hide on mouseleave
  // $(".site-nav__mousehover:first-child").addClass("active");
  $(".site-nav__mousehover").on("mouseenter", function () {
    var data_id = $(this).data("id");
    $(".site-nav__mousehover").removeClass("active");
    $(this).addClass("active");
    $(".site-nav__engagement-ring ul.site-nav__childlist-item").addClass(
      "hide"
    );
    $(`#${data_id}`).removeClass("hide");
  });
  $(".site-nav__collections-banners li:first-child").addClass("active");
  $(".site-nav__collections-banners li").on("mouseenter", function () {
    var data_id = $(this).data("id");
    $(".site-nav__collections-banners li").removeClass("active");
    $(this).addClass("active");
    $(".site-nav__collections-banners .banner").addClass("hide");
    $(`#${data_id}`).removeClass("hide");
  });

  // show popup on more info click
  $(document).on(
    "click",
    ".schedule-appointment-btn,.site-header__book-appointment,.product__addon-schedule-appointment,.btn-book-appointment",
    function (e) {
      e.preventDefault();
      $("body").addClass("show-website-popup");
      $("#website-video-appointment").addClass("show-popup-content");
    }
  );
  $(".virtual-appointmet-btn").on("click", function () {
    $("body").removeClass("show-website-popup");
    $(this).closest(".popup-overlay-content").removeClass("show-popup-content");
    Calendly.initPopupWidget({
      url: `https://calendly.com/with-clarity/book-a-virtual-appointment`,
    });
    return false;
  });
  $(".store-appointmet-btn").on("click", function (e) {
    e.preventDefault();
    $("body").removeClass("show-website-popup");
    $(this).closest(".popup-overlay-content").removeClass("show-popup-content");
    Calendly.initPopupWidget({
      url: `https://calendly.com/with-clarity/soho-ny-showroom`,
    });
    return false;
  });
  $("#btn_showroom_appointment").on("click", function (e) {
    e.preventDefault();
    Calendly.initPopupWidget({
      url: `https://calendly.com/with-clarity/soho-ny-showroom`,
    });
    return false;
  });
  $("#btn_virtual_appointment").on("click", function (e) {
    e.preventDefault();
    Calendly.initPopupWidget({
      url: `https://calendly.com/with-clarity/book-a-virtual-appointment`,
    });
    return false;
  });
  $(".page-bridal-party .media-with-content .btn").on("click", function (e) {
    e.preventDefault();
    Calendly.initPopupWidget({
      url: `https://calendly.com/withclarity/soho-new-york-bridal-event`,
    });
    return false;
  });

  // Education section -- Education Page Menu
  if ($(window).width() < 750) {
    var $educationMenu = $(".page-education-template .education-menu");
    var educationMenuItem = $(".education-menu li.active");
    $educationMenu.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: false,
      speed: 10,
      fade: true,
      cssEase: "linear",
    });

    var activeSlide = $(educationMenuItem).data("slick-index");
    $educationMenu.slick("slickGoTo", activeSlide);

    let prevChildLink = $(".education-menu .slick-current")
      .prev(".slick-slide")
      .children("a")
      .attr("href");
    let nextChildLink = $(".education-menu .slick-current")
      .next(".slick-slide")
      .children("a")
      .attr("href");

    let prevBtn = $(".education-menu .slick-prev:not(.slick-disabled)");
    let nextBtn = $(".education-menu .slick-next:not(.slick-disabled)");
    prevBtn.on("click", function () {
      location.href = prevChildLink;
    });
    nextBtn.on("click", function () {
      location.href = nextChildLink;
    });

    // Education sidebar - mobile
    let eduSidebar = $(".education-sidebar");
    let eduSidebarItem = $(".education-sidebar li.active");
    let eduSidebarItemWidth = eduSidebarItem.width();
    let eduSidebarWidth = eduSidebar.width();
    let offset = eduSidebarWidth / 2 - eduSidebarItemWidth / 2;
    // eduSidebar.animate({scrollLeft: eduSidebarItem.offset().left - offset}, 'slow');
    eduSidebar.scrollLeft(eduSidebarItem.offset().left - offset);
  }

  // Get the section ID from the URL
  const sectionId = window.location.hash.substring(1);
  if (sectionId) {
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  }
});
